<template>
  <div class="container">
    <img :src="require('@/assets/img/' + image)"/>
    <div class="content">
      <slot/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'badge',
  props: {
    image: {
      required: true
    },
  }
};
</script>
<style lang="scss" scoped>
@import '../assets/css/definitions';
  .container {
    margin-left: 1%;
    margin-right: 1%;
    background: #e6e6e6 !important;
    box-shadow: 2px 2px 2px 2px $color-acc;
    width: 30%;
    img {
      width: 100%;
      margin-top: 2%;
      // margin-bottom: 1%;
      // margin-left: auto;
      // margin-right: auto;
    }

    .content {
      word-wrap: break-word;
      //background: $color-bg;
      border-radius: 25px;
      margin: 1%;
      padding: 3%;
      //height: 500px;
    }
  }

  @media screen and (max-width: 500px) {
    .container {
      img {
        width: 50%;
      }
      .content {
        font-size: 10px;
      }
    }
  }
</style>

